import React from 'react';
import Toolbar from './toolbar';
import LayerTogglers from './layer-togglers';

const MapToolbar = ({
    // Drawing tools
    drawPolygon,
    drawCircle,
    stopDrawing,
    toggleDrawHouse,
    undo,
    undoIsActive,
    hasAreas,
    isLoading,
    
    // Selection
    selectionType,
    hasSelectionType,
    onSelectionChange,
    
    // Search
    selectSearchedArea,
    
    // Map type
    type,
    
    // Layer toggles
    onToggleUnits,
    onToggleSaleDistrict,
    saleDistrictsVisible,
    unitsVisible,
    
    // Tools
    onAddTools
}) => {
    return (
        <>
            <div className="create-district-map__toolbar">
                <Toolbar 
                    // Drawing tools
                    drawPolygon={drawPolygon}
                    drawCircle={drawCircle}
                    stopDrawing={stopDrawing}
                    toggleDrawHouse={toggleDrawHouse}
                    undo={undo}
                    undoIsActive={undoIsActive}
                    hasAreas={hasAreas}
                    isLoading={isLoading}
                    
                    // Selection
                    selectionType={selectionType}
                    hasSelectionType={hasSelectionType}
                    changeSelection={onSelectionChange}
                    
                    // Search
                    selectSearchedArea={selectSearchedArea}
                    
                    // Map type
                    type={type}
                    
                    // Tools
                    addTools={onAddTools}
                />
            </div>

            <div className="toolbar create-district-map__toolbar-bottom">
                <LayerTogglers 
                    type={type}
                    toggleUnits={onToggleUnits}
                    unitsVisible={unitsVisible}
                    toggleSaleDistrict={onToggleSaleDistrict}
                    saleDistrictsVisible={saleDistrictsVisible}
                />
            </div>
        </>
    );
};

export default MapToolbar;